import { ApostleFilterData } from '@apeiron/apostle'
import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import useMakeApostleFilter from '@src/deserialize/hook/useMakeApostleFilter'

const useFetchApostleFilterJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  const { makeApostleFilter } = useMakeApostleFilter()

  return useReactQueryFetchJson<ApostleFilterData>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.APOSTLE_FILTERS,
    deserialize: makeApostleFilter
  })
}

export default useFetchApostleFilterJson
